


<template>
  
  <v-container fluid grid-list-lg>
    <v-layout row align-center>
      <v-flex class="text-xs-center">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>

export default {
  name: 'Verify',
  data () {
    return {}
  },
  mounted: function() {
    if(!this.token) {
      this.invalidToken();
    } else {
      this.validate();
    }
  },
  computed: {
    token: function() {
      return this.$route.params.token;
    }
  },
  methods: {
    validate: function() {
      
      let data = {
        token: this.token
      }
      this.$http.post('auth/verify', data)
        .then(response => {
          this.$store.commit('updateAccessToken', response.data.access_token);
          delete(response.data.access_token);
          this.$store.commit('setUser', response.data);
          this.$router.push({name: 'account-trips'});
          this.$store.dispatch('checkForUpdates');
        })
        .catch(error => {
          this.invalidToken();
        })
    },
    invalidToken: function() {
      this.$swal.fire('Invalid Request', 'The validation token has either expired or is incorrect');
      this.$router.push({name: 'auth'});
    }
  }
}
</script>
